export const getInitialState = (): any => ({
  dataProcessingGroupByProgressData: {}
});
